import { config } from '../config';
import { headers, APIResponse, stleaf, fetchAPI, SpanTag } from '../helpers';

/**
 * Function to transform references to status -> category for backend.
 *
 * TODO: this is obviously terrible. refactor fault 'status' to fault 'category'
 * in the rest of the front end (with a TS enum preferably)
 */
function patchObj(obj) {
  if (obj.status) {
    obj.category = obj.status;
    delete obj.status;
  }

  // remove null vals they aren't part of the filter
  for (let prop in obj) {
    const val = obj[prop];
    if (val === null) delete obj[prop];
  }
}

export const getFaultPrioritiesList = (st: SpanTag) => {
  const url = new URL(`${config.API_URL}/v1/powercor-faults/priorities`);
  return fetchAPI(stleaf(st, 'mtmb6i'), url.toString(), {
    method: 'GET',
    credentials: 'include',
    headers,
  });
};

type FaultPart =
  | 'assetGroup'
  | 'assetSubgroup'
  | 'object'
  | 'damageDescription'
  | 'causeDescription';
type FilteredFaultListOpts = {
  [key in FaultPart]: 'string';
};
export const getDistinctFilteredFaultList = (
  st: SpanTag,
  target: FaultPart,
  opts: FilteredFaultListOpts,
) => {
  patchObj(opts);
  const qObj = { ...opts, target };
  const queryString = Object.keys(qObj)
    .map((key) => key + '=' + qObj[key])
    .join('&');
  const url = new URL(`${config.API_URL}/v1/powercor-faults?${queryString}`);
  return fetchAPI(stleaf(st, 'upi5tu'), url.toString(), {
    method: 'GET',
    credentials: 'include',
    headers,
  });
};

export const getAssetGroups = (st: SpanTag, obj: any) => {
  return getDistinctFilteredFaultList(st, 'assetGroup', obj);
};

export const getAssetSubgroups = (st: SpanTag, obj: any) => {
  return getDistinctFilteredFaultList(st, 'assetSubgroup', obj);
};

export const getObjects = (st: SpanTag, obj) => {
  return getDistinctFilteredFaultList(st, 'object', obj);
};

export const getDamageDescriptions = (st: SpanTag, obj) => {
  return getDistinctFilteredFaultList(st, 'damageDescription', obj);
};

export const getCauseDescriptions = (st: SpanTag, obj) => {
  return getDistinctFilteredFaultList(st, 'causeDescription', obj);
};

export const postPowercorReport = (st: SpanTag, obj) => {
  patchObj(obj.info);
  const url = new URL(`${config.API_URL}/v1/powercor-report`);
  return fetchAPI(stleaf(st, 'quaen3'), url.toString(), {
    method: 'POST',
    credentials: 'include',
    headers,
    body: JSON.stringify(obj),
  });
};

export const getReportsCount = (st: SpanTag, assetId) => {
  const url = new URL(
    `${config.API_URL}/v1/powercor-report/reports-count/${assetId}`,
  );
  return fetchAPI(stleaf(st, 'eeji7a'), url.toString(), {
    method: 'GET',
    credentials: 'include',
    headers,
  });
};

export const getReportList = (st: SpanTag, assetId, category) => {
  // category was formerly 'status'
  const url = new URL(
    `${config.API_URL}/v1/powercor-report/reports-list/${assetId}`,
  );
  return fetchAPI(stleaf(st, 'yeey5u'), url.toString(), {
    method: 'POST',
    credentials: 'include',
    headers,
    body: JSON.stringify({ category }),
  });
};

export const getReportedItem = (st: SpanTag, id) => {
  const url = new URL(`${config.API_URL}/v1/powercor-report/${id}`);
  return fetchAPI(stleaf(st, 'iex3ee'), url.toString(), {
    method: 'GET',
    credentials: 'include',
    headers,
  });
};

export const deleteReportedItem = (st: SpanTag, id) => {
  const url = new URL(`${config.API_URL}/v1/powercor-report/${id}`);
  return fetchAPI(stleaf(st, 'mahk4z'), url.toString(), {
    method: 'DELETE',
    credentials: 'include',
    headers,
  });
};
